import { SSR } from "../../common/apiUrl/ssr/ssrUrl";
import { API } from "../../common/model/objectTypes";
import { archivedReturnInfo } from "../../utils/apiDescription/ssr/archivedReturns";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { resendAccessLinkRequestBody, sendReminderRequestBody, SSR_ArchivedReturn_getAccessLinkRequestParameter, SSR_ArchivedReturn_getAccessLinkResponseBody, SSR_ArchivedReturnAPI_ArchivedReturnsRequestParameter, SSR_ArchivedReturnAPI_ArchivedReturnsResponseBody, SSR_ArchivedReturnAPI_DeleteReturn_AND_MoveToDeliveredRequestBody, SSR_ArchivedReturnAPI_SignatureStatusRequestParameter, SSR_ArchivedReturnAPI_SignatureStatusResponseBody, SSR_ArchivedReturnAPI_SignerInformationResponseBody } from "../../utils/ssr/apiObjects";
import { SSR_ArchivedReturn_ArchivedReturnsJsonRequestCurl, SSR_ArchivedReturn_getAccessLinkJsonRequestCurl, SSR_ArchivedReturnAPI_DeleteReturnJsonRequestCurl, SSR_ArchivedReturnAPI_MoveToDeliveredJsonRequestCurl, SSR_ArchivedReturnAPI_RecallReturnJsonRequestCurl, SSR_ArchivedReturnAPI_ResendAccessLinkJsonRequestCurl, SSR_ArchivedReturnAPI_SendReminderJsonRequestCurl, SSR_ArchivedReturnAPI_SignatureStatusJsonRequestCurl, SSR_ArchivedReturnAPI_SignerInformationJsonRequestCurl } from "../../utils/ssr/sampleJsonRequest";
import { SSR_ArchivedReturn_archivedReturnsJsonResponse, SSR_ArchivedReturn_getAccessLinkJsonResponse, SSR_ArchivedReturnAPI_SignatureStatusJsonResponse, SSR_ArchivedReturnAPI_SignerInformationJsonResponse } from "../../utils/ssr/sampleJsonResponse";

const AccessLink: API = {
    name: "Access Link",
    url: `${API_BASE_URL}/${SSR.ARCHIVED.ACCESS_LINK_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: archivedReturnInfo.accessLink,
    requestBody: SSR_ArchivedReturn_getAccessLinkRequestParameter,
    responseBody: SSR_ArchivedReturn_getAccessLinkResponseBody,
    jsonRequest: SSR_ArchivedReturn_getAccessLinkJsonRequestCurl,
    jsonResponse: SSR_ArchivedReturn_getAccessLinkJsonResponse,
}

const All: API = {
    name: "Archived Returns",
    url: `${API_BASE_URL}/${SSR.ARCHIVED.ARCHIVED_RETURNS_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: archivedReturnInfo.archivedReturnInfo,
    requestBody: SSR_ArchivedReturnAPI_ArchivedReturnsRequestParameter,
    responseBody: SSR_ArchivedReturnAPI_ArchivedReturnsResponseBody,
    jsonRequest: SSR_ArchivedReturn_ArchivedReturnsJsonRequestCurl,
    jsonResponse: SSR_ArchivedReturn_archivedReturnsJsonResponse,
}

const DeleteReturn: API = {
    name: "Delete Return",
    url: `${API_BASE_URL}/${SSR.ARCHIVED.DELETE_RETURN_URL}`,
    method: "DEL",
    headers: requestHeaderWithCallback,
    apiInfo: archivedReturnInfo.deleteReturnInfo,
    requestBody: SSR_ArchivedReturnAPI_DeleteReturn_AND_MoveToDeliveredRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: SSR_ArchivedReturnAPI_DeleteReturnJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

const MoveToDelivered: API = {
    name: "Move To Delivered",
    url: `${API_BASE_URL}/${SSR.ARCHIVED.MOVE_TO_DELIVERED_URL}`,
    method: "PUT",
    headers: requestHeaderWithCallback,
    apiInfo: archivedReturnInfo.moveToDeliveredInfo,
    requestBody: SSR_ArchivedReturnAPI_DeleteReturn_AND_MoveToDeliveredRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: SSR_ArchivedReturnAPI_MoveToDeliveredJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

const RecallReturn: API = {
    name: "Recall Return",
    url: `${API_BASE_URL}/${SSR.ARCHIVED.RECALL_RETURN_URL}`,
    method: "PUT",
    headers: requestHeaderWithCallback,
    apiInfo: archivedReturnInfo.recallReturnInfo,
    requestBody: SSR_ArchivedReturnAPI_DeleteReturn_AND_MoveToDeliveredRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: SSR_ArchivedReturnAPI_RecallReturnJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

const ResendAccessLink: API = {
    name: "Resend Access Link",
    url: `${API_BASE_URL}/${SSR.ARCHIVED.RESEND_ACCESS_LINK_URL}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: archivedReturnInfo.resendAccessLinkInfo,
    requestBody: resendAccessLinkRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: SSR_ArchivedReturnAPI_ResendAccessLinkJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const SendReminder: API = {
    name: "Send Reminder",
    url: `${API_BASE_URL}/${SSR.ARCHIVED.SEND_REMINDER_URL}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: archivedReturnInfo.sendReminderInfo,
    requestBody: sendReminderRequestBody,
    responseBody: commonResponseBody,
    jsonRequest:SSR_ArchivedReturnAPI_SendReminderJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const SignatureStatus: API = {
    name: "Signature Status",
    url: `${API_BASE_URL}/${SSR.ARCHIVED.SIGNATURE_STATUS_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: archivedReturnInfo.signatureStatusInfo,
    requestBody: SSR_ArchivedReturnAPI_SignatureStatusRequestParameter,
    responseBody: SSR_ArchivedReturnAPI_SignatureStatusResponseBody,
    jsonRequest:SSR_ArchivedReturnAPI_SignatureStatusJsonRequestCurl,
    jsonResponse: SSR_ArchivedReturnAPI_SignatureStatusJsonResponse,
}

const SignerInformation: API = {
    name: "Signer Information",
    url: `${API_BASE_URL}/${SSR.ARCHIVED.SIGNER_INFORMATION_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: archivedReturnInfo.signerInformationInfo,
    requestBody: SSR_ArchivedReturnAPI_SignatureStatusRequestParameter,
    responseBody: SSR_ArchivedReturnAPI_SignerInformationResponseBody,
    jsonRequest:SSR_ArchivedReturnAPI_SignerInformationJsonRequestCurl,
    jsonResponse: SSR_ArchivedReturnAPI_SignerInformationJsonResponse,
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case "Access Link":
            return AccessLink;
        case "All":
            return All;
        case "Delete Return":
            return DeleteReturn;
        case "Move To Delivered":
            return MoveToDelivered;
        case "Recall Return":
            return RecallReturn;
        case "Resend Access Link":
            return ResendAccessLink;
        case "Send Reminder":
            return SendReminder;
        case "Signature Status":
            return SignatureStatus;
        case "Signer Information":
            return SignerInformation;
    }
}